import { useParams } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import studentsAPI from "../../../services/students";
import { TabPanel, TabView } from "primereact/tabview";
import StudentDetailHeader from "../../trainings/students/components/StudentDetailHeader";
import StudentRegistrationFormComponent from "./components/StudentRegistrationFormComponent";
import RegistrationStepsComponent from "./components/RegistrationStepsComponent";
import StudentDetailComponent from "../../trainings/students/components/StudentDetailComponent";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import StudentUpdatesHistoryListComponent from "../../trainings/students/components/StudentUpdatesHistoryListComponent";
import { useAuthContext } from "../../../hooks/useAuthContext";

const CandidateDetailPage = () => {
  const { currentMembership } = useAuthContext();
  //
  //
  const params = useParams();
  const studentId = params.candidateId;
  const schoolId = params.schoolId;
  const trainingId = params.registrationId;
  const accessToken = "";

  //
  const studentQuery = studentsAPI.GetOne(
    schoolId,
    trainingId,
    accessToken,
    studentId
  );
  const studentObj = studentQuery?.data?.data;
  const canViewUpdatesHistory = currentMembership?.is_admin || currentMembership?.is_owner;
  //

  return (
    <>
      <MeaPage
        query={studentQuery}
        showBackButton={false}
        header={<StudentDetailHeader student={studentObj} schoolId={schoolId} trainingId={trainingId} callback={() => {
          studentQuery?.refetch()
        }} />}
      >


        <div className="mt-0">
          <TabView activeIndex={1}>
            <TabPanel header="Fiche élève" leftIcon="pi pi-user mr-2" className="mr-2">
              <StudentDetailComponent student={studentObj} schoolId={schoolId} trainingId={trainingId} link="candidates" />
            </TabPanel>
            <TabPanel header="Dossier d'inscription" leftIcon="pi pi-book mr-2" className="mr-2">
              <div className="m-0">
                <RegistrationStepsComponent student={studentObj} schoolId={schoolId} trainingId={trainingId}
                  callback={() => {
                    studentQuery?.refetch()
                  }} />
                <StudentRegistrationFormComponent
                  student={studentObj} schoolId={schoolId} trainingId={trainingId}
                  callback={() => {
                    studentQuery?.refetch()
                  }}
                />
              </div>
            </TabPanel>

            {canViewUpdatesHistory && (
              <TabPanel header="Historique des modifications" leftIcon="pi pi-pencil mr-2" className="ml-2">
                <MeaLoadingContent objectQuery={studentQuery}>
                  <StudentUpdatesHistoryListComponent student={studentObj} schoolId={schoolId} trainingId={trainingId} />
                </MeaLoadingContent>
              </TabPanel>
            )}
          </TabView>
        </div>
      </MeaPage>
    </>
  );
};
export default CandidateDetailPage;
